import { faDigits } from "../../../tools/tools";
import { statusTone } from "../../auxiliary/report/ReportPage";

// state text -> bar colour (same reading as the status pills in the reports)
const TONE_COLORS = { success: "#37b399", warning: "#f5a623", error: "#e64225" };

// each state as a bar sized by its share of the group
const ListProgress = ({ groups = [] }) =>
	groups.length ? (
		groups.map((g, gi) => {
			const total = g.rows.reduce((s, r) => s + (Number(r?.count) || 0), 0);
			return (
				<div className="progress-group" key={gi}>
					{g.title && (
						<h3>
							{g.title} <span>{faDigits(total)} مورد</span>
						</h3>
					)}
					<ul className="progress-rows">
						{g.rows.map((item, key) => {
							const count = Number(item?.count) || 0;
							const pct = total ? Math.round((count / total) * 100) : 0;
							return (
								<li key={key}>
									<div className="progress-line">
										<span>{item?.state}</span>
										<strong>
											{faDigits(count)} <small>({faDigits(pct)}٪)</small>
										</strong>
									</div>
									<div className="progress-track" aria-hidden="true">
										<span style={{ width: `${pct}%`, background: TONE_COLORS[statusTone(item?.state)] ?? "#8c8c8c" }} />
									</div>
								</li>
							);
						})}
					</ul>
				</div>
			);
		})
	) : (
		<p className="dash-empty">گزارشی ثبت نشده است.</p>
	);

export default ListProgress;
